import React from 'react';
export const MessageLayout = ({ children, dir, }) => {
    return (React.createElement("div", { dir: dir, style: {
            display: 'grid',
            height: '100%',
            placeItems: 'center center',
            placeContent: 'center',
            textAlign: 'center',
            gap: '12px',
            padding: '0 20px',
            whiteSpace: 'pre-wrap',
        } }, children));
};
//# sourceMappingURL=MessageLayout.js.map